<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3675_10472)">
      <mask
        id="mask0_3675_10472"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <path d="M40 0H0V40H40V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3675_10472)">
        <path
          d="M32.4998 19.1665H29.1665V37.4998H32.4998V19.1665Z"
          fill="#D6D2D0"
        />
        <path
          d="M20.833 31.25H24.1663V37.9167H20.833V31.25Z"
          fill="#3A8534"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M20.833 18.3335H24.1663V21.6668H20.833V18.3335Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M20.833 12.0835H24.1663V15.4168H20.833V12.0835Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M20.833 5.8335H24.1663V9.16683H20.833V5.8335Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M31.2495 22.9165H33.3328V26.2498H31.2495V22.9165Z"
          fill="white"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M31.2495 29.5835H33.3328V32.9168H31.2495V29.5835Z"
          fill="white"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M14.166 18.3335H17.4993V21.6668H14.166V18.3335Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M14.166 12.0835H17.4993V15.4168H14.166V12.0835Z"
          fill="#3A8534"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M20.833 24.5835H24.1663V27.9168H20.833V24.5835Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M14.166 5.8335H17.4993V9.16683H14.166V5.8335Z"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M36.666 37.4998V19.1665H29.166"
          stroke="#5C5957"
          stroke-width="1.66667"
        />
        <path d="M0 38.3335H40" stroke="#5C5957" stroke-width="2.5" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.3747 2.5C29.3747 1.46447 28.5353 0.625 27.4997 0.625H10.833C9.79751 0.625 8.95801 1.46447 8.95801 2.5V15.871C9.71217 15.9627 10.4179 16.2182 11.0413 16.6022V2.70833H27.2913V38.3333H29.3747V2.5ZM17.3177 28.3333C17.4368 27.8539 17.5001 27.3512 17.5001 26.8333C17.5001 25.8752 17.2835 24.9698 16.8983 24.1667H17.9163V28.3333H17.3177Z"
          fill="#5C5957"
        />
        <path
          d="M11.0085 23.0841L11.1848 21.7054C11.201 21.5781 11.2095 21.4476 11.2095 21.3143C11.2095 19.6807 9.922 18.3564 8.33367 18.3564C6.74542 18.3564 5.45788 19.6807 5.45788 21.3143C5.45788 21.5321 5.48053 21.7428 5.52301 21.9445L5.78083 23.1694L4.64841 23.632C2.87393 24.3569 1.62346 26.138 1.62346 28.2159C1.62346 30.9386 3.76937 33.1458 6.41648 33.1458V34.6247C2.97523 34.6247 0.185547 31.7554 0.185547 28.2159C0.185547 25.5116 1.81416 23.1984 4.11766 22.2575C4.05367 21.9535 4.01997 21.6379 4.01997 21.3143C4.01997 18.8639 5.95129 16.8774 8.33367 16.8774C10.7161 16.8774 12.6474 18.8639 12.6474 21.3143C12.6474 21.5122 12.6348 21.7072 12.6104 21.8983C14.8166 22.3402 16.4818 24.3386 16.4818 26.737C16.4818 29.4597 14.3359 31.6669 11.6888 31.6669L11.6679 31.6668C11.153 32.4941 10.4583 33.1917 9.6405 33.7012V31.8748C10.1086 31.3587 10.0413 31.4665 10.4569 30.8694L10.8833 30.1844L11.674 30.1879H11.6888C13.5418 30.1879 15.0439 28.6429 15.0439 26.737C15.0439 25.0598 13.8791 23.6591 12.3355 23.3499L11.0085 23.0841Z"
          fill="#5C5957"
        />
        <path
          d="M13.8321 29.4087H1.76904C2.11916 30.9379 3.49973 33.14 6.42001 33.14C8.31779 33.0504 9.77392 32.1124 10.5777 30.6769L10.8959 30.1794C10.8959 30.1794 11.9781 30.2529 12.6306 30.0489C13.4298 29.7992 13.8321 29.4087 13.8321 29.4087Z"
          fill="#D6D2D0"
        />
        <path
          d="M5.27779 32.5366C5.8403 32.5366 6.29631 32.0692 6.29631 31.4926C6.29631 30.9161 5.8403 30.4487 5.27779 30.4487C4.71528 30.4487 4.25928 30.9161 4.25928 31.4926C4.25928 32.0692 4.71528 32.5366 5.27779 32.5366Z"
          fill="#83C539"
        />
        <path
          d="M8.84325 24.1851H7.31543V37.7565H8.84325V24.1851Z"
          fill="#5C5957"
        />
        <path
          d="M8.3335 28.8828L10.8798 25.229"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
        <path
          d="M8.33342 30.4487L5.27783 27.3169"
          stroke="#5C5957"
          stroke-width="0.833333"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3675_10472">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
